import React, { useEffect } from "react";
import "../IndexPage/IndexPage.css";

function SakePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="sakenew-background"></div>
      <div className="card-container">
        <img loading="lazy" decoding="async" width="1500" height="2121" className="pdf-sake" src="img/sake.webp" alt="Sake"></img>
      </div>
    </div>
  );
}

export default SakePage;
